import { render } from "./UiPropReachText.vue?vue&type=template&id=0959b7c7"
import script from "./UiPropReachText.vue?vue&type=script&lang=js"
export * from "./UiPropReachText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__